export interface QuickDateRange {
  dateFrom?: Date;
  dateTo?: Date;
}

/** Resolves a report toolbar quick date option (this-week, last-month, ...) to a date range. */
export const getQuickDateRange = (range: string): QuickDateRange => {
  const today = new Date();
  const dayOfWeek = today.getDay();
  switch (range) {
    case 'this-week': {
      const s = new Date(today); s.setDate(today.getDate() - dayOfWeek); s.setHours(0,0,0,0);
      const e = new Date(s); e.setDate(s.getDate() + 6); e.setHours(23,59,59,999);
      return { dateFrom: s, dateTo: e };
    }
    case 'last-week': {
      const s = new Date(today); s.setDate(today.getDate() - dayOfWeek - 7); s.setHours(0,0,0,0);
      const e = new Date(s); e.setDate(s.getDate() + 6); e.setHours(23,59,59,999);
      return { dateFrom: s, dateTo: e };
    }
    case 'this-month': {
      const s = new Date(today.getFullYear(), today.getMonth(), 1);
      const e = new Date(today.getFullYear(), today.getMonth() + 1, 0); e.setHours(23,59,59,999);
      return { dateFrom: s, dateTo: e };
    }
    case 'last-month': {
      const s = new Date(today.getFullYear(), today.getMonth() - 1, 1);
      const e = new Date(today.getFullYear(), today.getMonth(), 0); e.setHours(23,59,59,999);
      return { dateFrom: s, dateTo: e };
    }
    default: return {};
  }
};
